/**
 * Fictora 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const fictoraPaymentConfig: BrandPaymentConfig = {
  brand: 'fictora',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/fictora/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/fictora/vip_bg.webp',
      memberSubscribeBg: '/images/fictora/member_subscribe_bg.webp',
      vipIcon: '/images/fictora/vip_icon2.png',
      vipDiscountIcon: '/images/fictora/vip_discount.png',
      discountBg: '/images/fictora/discount.avif',
      showVipIcon: false,
    },
    colors: {
      redGradient: 'linear-gradient(132deg, #FF2D89 0%, #FF8AB9 100%)',
      purpleTextGradient: 'linear-gradient(90.00000000000006deg, rgba(223,137,38,0.56) 0%, rgba(238,177,114,0.3) 100%)',
      subscribeText1: '#FFD483',
      subscribeText2: '#FFD483',
      subscribeText3: '#FFD483',
      subscribeText4: '#AC6D1F',
      // 金色图卡上的金额：subscribeText2 浅金色在图卡上不可见，按蓝湖标注使用深棕色 rgba(125,56,11,1)
      subscribeImagePrice: '#7D380B',
    },
    darkPaymentSelector: true,
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    darkPaymentSelector: true,
    colors: {
      coinsGradient: 'linear-gradient( 180deg, #FFE9B8 0%, #FFF5E1 100%)',
      coinsPopupText1: '#AA4E0F',
      coinsPopupText2: '#FF2D89',
      coinsPopupText3: '#AA4E0F',
      coinsPopupText4: '#FFFFFF',
      vipBg: brandColors!.bg.card,
      subscribeActiveBg: '#2C2A28',
      purpleTextGradient: 'linear-gradient(90deg, rgba(215,164,94,0.7) 0%, rgba(94,74,53,0.6) 100%)',
      pinkGradient: 'linear-gradient( 90deg, #FF2D89 0%, #FF8AB9 100%)',
      memberSubscribeBg: '/images/fictora/chapter/member_subscribe_bg.webp',
      showVipIcon: false,
    },
  },
}
